module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"missing_required_fields":"条件を満たしていないため、報酬を受け取れません。"}}')
  delete Component.options._Ctor
}
